<div class="card">
  <div class="card-header card-header-squirrel">
      <h4>{{this.translate.data['DELETEGROUPROLE'] | translate}}</h4>
  </div>
  <div class="card-body">
      <form [formGroup]="groupRoleForm" novalidate>

          <mat-form-field class="form-element" style="width: 0; height: 0;">
              <input matInput hidden formControlName="projectId" readonly>
          </mat-form-field>
  
          <mat-form-field class="form-element" style="width: 0; height: 0;">
              <input matInput hidden formControlName="groupRoleId" readonly>
          </mat-form-field>
  
          <div class="row">
              <div class="col-md-12">
                  <mat-form-field class="example-full-width">
                      <input matInput placeholder="{{this.translate.data['GROUPROLENAME'] | translate}}" disabled="disabled" formControlName="name" readonly>
                  </mat-form-field>
              </div>
          </div>            

          <div class="row">
            <!-- <button  mat-raised-button class="btn btn-squirrel pull-left" (click)="cancel()" color="primary">ABBRUCH</button> -->
            <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button (click)="cancel()" >
                <mat-icon>close</mat-icon>
            </button> -->
            <!-- <span style="flex: 1 1 auto"></span>
            <button  mat-raised-button class="btn btn-squirrel pull-right" (click)="deleteGroupRole(data.id)" color="primary">{{this.translate.data['DELETEGROUPROLE'] | translate}}</button> -->
            <!-- <button matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}" mat-button (click)="deleteGroupRole(data.id)">
                <mat-icon>add</mat-icon>
            </button> -->
            <a>
                <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                (click)="cancel()" >Abbruch</button>
            </a>                                                
            <span style="flex: 1 1 auto"></span>
            <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['DELETEGROUPROLE'] | translate}}"
                                    (click)="deleteGroupRole(data.id)" >Löschen</button>
            </a>                   

        </div>    
    </form>
  </div>
</div>
